import React from 'react';
import { Form, Col } from 'react-bootstrap';

const styles = {
  visible: {
    visibility: 'visible',
    opacity: 1,
    transition: 'opacity 0.5s linear',
  },
  hidden: {
    visibility: 'hidden',
    opacity: 0,
    transition: 'visibility 0s 0.5s, opacity 0.5s linear',
  },
};

export default function FilterInput(props) {
  const { label, filterValue, setFilterValue, size } = props;

  return (
    <Form.Group as={Col} md={size}>
      <Form.Label style={{ fontSize: '0.9rem', marginBottom: '0' }}>
        <div style={filterValue !== '' ? styles.visible : styles.hidden}>
          {label}
        </div>
      </Form.Label>
      <Form.Control
        placeholder={label}
        onChange={(e) => setFilterValue(e.target.value)}
      />
    </Form.Group>
  );
}
